import {
  playSentenceVoiceSample,
  previewSentenceVoice,
} from "@-/dev.improve.haniverse.lib.sentence.speech";
import {
  getNeuralSentenceVoice,
  type SentenceVoiceId,
} from "@-/dev.improve.haniverse.lib.sentence.speech.voice-catalog";
import { isNeuralSentenceVoiceInstalled } from "@-/dev.improve.haniverse.lib.sentence.speech.voices";
import { SENTENCE_VOICE_SAMPLES } from "@-/dev.improve.haniverse.assets.sentence-voice-samples";

/** The sentence every sample says: everyday words with 3rd-tone sandhi, 一 and a neutral tone. */
export const SENTENCE_VOICE_SAMPLE_TEXT = "今天天气很好，我们一起去公园散散步吧。";

/**
 * Let the learner hear a voice: an installed voice speaks the sample live (at their chosen pace);
 * one not downloaded yet plays its bundled recording of the same sentence; the system voice always
 * speaks live, since what it sounds like depends on the device.
 */
export function previewSentenceVoiceSample({
  ownerId,
  voiceId,
}: {
  ownerId: string;
  voiceId: SentenceVoiceId;
}): void {
  const voice = getNeuralSentenceVoice(voiceId);
  const sample = voice === undefined ? undefined : SENTENCE_VOICE_SAMPLES.get(voice.id);
  if (sample !== undefined && voice !== undefined && !isNeuralSentenceVoiceInstalled(voice)) {
    playSentenceVoiceSample({ ownerId, source: sample });
    return;
  }
  previewSentenceVoice({ ownerId, sentence: SENTENCE_VOICE_SAMPLE_TEXT, voiceId });
}
